$(document).ready(function(){
  $('[data-autocomplete-true] form').each(function() {
    var $this = $(this);
    var input = $this.find('input[name="q"]');
    // Adding a list for showing search results.
    $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo($this);

    input.attr('autocomplete', 'off').on('input', function() {
      if ($(this).val().length > 1) {
        var term = $(this).val();
        getResults(term, $this);
      } else {
        $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
      }
    });
  });
  function getResults(term, $this) {
    var inputval = term;
    if ($this.find('[name="type"]').length > 0) {
      var searchType = $this.find('[name="type"]').val();
    }
    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": 5,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,vendor,product_type,tag"
        }
      }
    }).done(function(response) {
      var suggestions = [
        response.resources.results.products,
        response.resources.results.pages,
        response.resources.results.articles
      ];
      var filteredResults = [];
      // Store results in array
      $.each(suggestions, function(index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) { // Ensure suggestion exists
          filteredResults.push(suggestion)
        }
      })
      // Display results
      setTimeout(function() {
        displayResults(filteredResults[0], $this, term);
      }, 500);
      setTimeout(function() {
        $('.search__results .search-title').each(function(){
          let term = inputval;
          let src_str = $(this).html();
          term = term.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
          let pattern = new RegExp("("+term+")", "gi");

          src_str = src_str.replace(pattern, "<mark>$1</mark>");
          src_str = src_str.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/,"$1</mark>$2<mark>$4");
          $(this).html(src_str);
        });
      }, 600);
    });
  }
  function displayResults(results, $this, term) {
    var $resultsWrapper = $this.find('.search__results-wrapper');
    var $resultsList = $this.find('.search__results');
    var root_url = '/search';
    $resultsWrapper.show();
    $resultsList.empty();
    if ($this.find('[name="type"]').length > 0) {
      var searchType = $this.find('[name="type"]').val();
    }
    if (results && results.length > 0) {
      $.each(results, function(index, result) {
        console.log(result);
        var link = $('<a tabindex="0"></a>').attr('href', result.url);
        if (root_url !== '/') {
          link = $('<a tabindex="0"></a>').attr('href', result.url);
        }
        // If result is an article
        if(result['price']) {
          link.append('<div class="search-title">' + result.title + '</div>');
        }else {
          console.log(result,"dm-1")
          link.append('<div class="search-result-wrapper"><img class="result-wrapper" src='+result.image+'><div class="search-title">' + result.title + '</div></div>');
        }
        // Wrap link and append to list
        link.wrap('<li class="item-result"></li>');
        $resultsList.append(link.parent());
      });

      $resultsList.parents('.search__results-wrapper').addClass('results-found');

    } else {
      // if no results
      var noResults = '<li class="item-result"><span class="no-results search-title">Sorry, no results!</span></li>';
      $resultsList.append(noResults);
      $resultsList.parents('.search__results-wrapper').removeClass('results-found');
    }
    $resultsList.show();
  }
  
});

$(document).on('click', '.search_block .search_box', function(e) {
  $(this).parent().addClass('focus-active');
});
$(document).on("click", function(event){
  var $trigger = $(".search-icon .search_block");
  if($trigger !== event.target && !$trigger.has(event.target).length){
    $(".search_block form").removeClass('focus-active');
    $('.search__results-wrapper').hide();
  }            
});
$('.mob_search_icon').click(function(){
  $(this).toggleClass('active-icons');
  $('.mobile_searchbar').slideToggle();
});